import { generatePath } from 'react-router';
import { createApi } from '@reduxjs/toolkit/query/react';

import { URL } from 'api/constants';

import { apiQuery } from '../../query';

import {
  PushCourseRequest,
  PushTenantRequest,
  ReplicationTenant,
  PushProjectRequest,
  ReplicationProject,
  DestinationsResponse,
  ReplicationDestination,
  PushProfileFormRequest,
  DestinationTenantsResponse,
  DestinationProjectsResponse,
} from './types';

export const replicationApi = createApi({
  baseQuery: apiQuery,
  reducerPath: 'replicationApi',
  endpoints: (build) => ({
    pushCourse: build.mutation<void, PushCourseRequest>({
      query: (data) => ({
        data,
        method: 'post',
        url: URL.REPLICATION_PUSH_COURSE,
      }),
    }),

    pushTenant: build.mutation<void, PushTenantRequest>({
      query: (data) => ({
        data,
        method: 'post',
        url: URL.REPLICATION_PUSH_TENANT,
      }),
    }),

    pushProject: build.mutation<void, PushProjectRequest>({
      query: (data) => ({
        data,
        method: 'post',
        url: URL.REPLICATION_PUSH_PROJECT,
      }),
    }),

    pushProfileForm: build.mutation<void, PushProfileFormRequest>({
      query: (data) => ({
        data,
        method: 'post',
        url: URL.REPLICATION_PUSH_PROFILE_FORM,
      }),
    }),

    destinations: build.query<ReplicationDestination[], void>({
      transformResponse: (response: DestinationsResponse) => response.data,
      query: () => ({
        method: 'get',
        url: URL.REPLICATION_DESTINATIONS,
      }),
    }),

    destinationTenants: build.query<ReplicationTenant[], string>({
      transformResponse: (response: DestinationTenantsResponse) =>
        response.data,
      query: (destinationName) => ({
        method: 'get',
        url: generatePath(URL.REPLICATION_DESTINATION_TENANTS, {
          destinationName,
        }),
      }),
    }),

    destinationProjects: build.query<ReplicationProject[], string>({
      transformResponse: (response: DestinationProjectsResponse) =>
        response.data,
      query: (destinationName) => ({
        method: 'get',
        url: generatePath(URL.REPLICATION_DESTINATION_PROJECTS, {
          destinationName,
        }),
      }),
    }),
  }),
});

export const {
  useDestinationsQuery,
  usePushCourseMutation,
  usePushTenantMutation,
  usePushProjectMutation,
  usePushProfileFormMutation,
  useLazyDestinationTenantsQuery,
  useLazyDestinationProjectsQuery,
} = replicationApi;

export type {
  PushCourseRequest,
  PushTenantRequest,
  ReplicationTenant,
  PushProjectRequest,
  ReplicationProject,
  ReplicationDestination,
};
